import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import BdcObseque from "../views/BdcObseque.vue";
import Accueil from "../views/Accueil.vue";
import Bdc from "../views/Bdc.vue";
import BdcObs from "../views/BdcTabObseques.vue";
import Pdf from "../pages/Pdf.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/pdf",
    name: "Pdf",
    component: Pdf,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/obseques",
    name: "Obsèques",
    component: BdcObseque,
  },
  {
    path: "/accueil",
    name: "Accueil",
    component: Accueil,
  },
  {
    path: "/bdc",
    name: "Bdc",
    component: Bdc,
  },
  {
    path: "/bdcobs",
    name: "BdcObs",
    component: BdcObs,
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
